<script setup>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import wootConstants from 'dashboard/constants/globals';
import ConversationView from '../conversation/ConversationView.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const currentUser = useMapGetter('getCurrentUser');
const conversationById = useMapGetter('getConversationById');

const conversationId = computed(() => Number(route.params.id || 0));

const selectedConversation = computed(() => {
  if (!conversationId.value) {
    return null;
  }

  return conversationById.value(conversationId.value) || null;
});

const shouldReturnToInboxList = computed(() => {
  if (!conversationId.value || !selectedConversation.value) {
    return false;
  }

  const assigneeId = selectedConversation.value?.meta?.assignee?.id;
  const isAssignedToCurrentAgent =
    Number(assigneeId) === Number(currentUser.value?.id);

  return (
    selectedConversation.value.status !== wootConstants.STATUS_TYPE.OPEN ||
    !isAssignedToCurrentAgent
  );
});

watch(
  shouldReturnToInboxList,
  shouldRedirect => {
    if (!shouldRedirect) {
      return;
    }

    router.replace({
      name: 'inbox_view',
      params: { accountId: route.params.accountId },
    });
  },
  { immediate: true }
);
</script>

<template>
  <ConversationView
    :conversation-id="conversationId"
    fixed-assignee-type="me"
    fixed-status="open"
    :page-title="t('SIDEBAR.INBOX')"
    hide-filter-controls
    hide-collapse-toggle
  />
</template>
